<template>
  <DropdownItem
    v-if="authUser.permission.canAccessSpotlightSearch && !this.currentEstate"
    icon="search"
    icon-classes="has-text-weight-light"
    :label="$t('Search anything')"
    :click-fn="triggerSpotlight"
    :data-e2e="NavCypressAttribute.buttons.SPOTLIGHT"
  />
</template>

<script>
import { HasAuthUserMixin } from '/@/modules/core/app/mixins/HasAuthUserMixin';
import DropdownItem from '@/modules/core/app/components/DropdownItem.vue';
import EventBus from '/@/modules/core/app/helpers/EventBus';
import { SpotlightEvent } from '@/modules/spotlight/events/SpotlightEvent';
import { HasCurrentEstateMixin } from '@/modules/core/app/mixins/HasCurrentEstateMixin';
import { NavCypressAttribute } from '@/modules/core/nav/constants/NavCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightSearchDropdownItem',
  mixins: [HasAuthUserMixin, HasCurrentEstateMixin],
  components: { DropdownItem },
  static: {
    NavCypressAttribute
  },
  methods: {
    triggerSpotlight() {
      EventBus.signal(SpotlightEvent.TRIGGER_SEARCH);
    }
  }
};
</script>
